export default __webpack_public_path__ + "static/media/asset-6.b15b7049.svg";